import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  Inject,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CommonService } from "../services/common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DataService, Response } from "../dataService/data.service";
import { GlobalVariable } from "../app.component";
import { NgbRatingConfig } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { ChangeDetectionStrategy } from "@angular/compiler/src/core";
import { Options } from "@angular-slider/ngx-slider";

@Component({
  selector: "app-review-improvement-test",
  templateUrl: "./review-improvement-test.component.html",
  styleUrls: ["./review-improvement-test.component.scss"],
})
export class ReviewImprovementTestComponent implements OnInit {
  @ViewChild("needimproveModal", { static: true }) needimproveModal: ElementRef;
  @ViewChild("thankyoumodal", { static: true }) thankyoumodal: ElementRef;

  name: String;
  feedback: String;
  slug_value: string;
  formal_ratting: String;
  faces_ratting: String;
  selected_rating: number = 0;
  ratings: number = 0;
  readonly: boolean = false;
  private BASE_URL = GlobalVariable;
  logo_url: String;
  business_name: String;
  customer_name: String;
  reviewp: String;
  reviewp1: String;
  reviewlike: any;
  reviewlike1: any;
  reviewdislike: any;
  reviewdislike1: any;
  poweredby: String;
  poweredby1: any;
  public reviewlikeStyle: any;
  public reviewlikeStyle1: any;
  public reviewdislikeStyle: any;
  public reviewdislikeStyle1: any;
  public loading = false;
  consumer_choice: String;
  feedback_scale: String;
  auto_redirect: String;
  negative_rating: number;
  reviewsby: any = [];
  redirectLink: any;
  optionForWhatsApp: any;
  options: Options = {
    showTicksValues: false,
    stepsArray: [
      { value: 1 },
      { value: 2, legend: "Very Disatisfield" },
      { value: 3 },
      { value: 4, legend: "Disatisfield" },
      { value: 5 },
      { value: 6, legend: "Average" },
      { value: 7 },
      { value: 8, legend: "Good" },
      { value: 9 },
      { value: 10, legend: "Excelent" },
    ],
    showTicks: true,
  };
  // set default value for ten point scale to 8.
  tenPointValue = 8;
  tenPointValueSubmitted: boolean = false;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private route: ActivatedRoute,
    private HttpService: DataService,
    private toastrService: ToastrService,
    config: NgbRatingConfig,
    private spinner: NgxSpinnerService
  ) {
    config.max = 5;
    config.readonly = true;
  }

  setTenPointNegativeLimit() {
    return this.negative_rating * 2;
  }

  ScaleOptionCheckTenPointScale(option) {
    if (this.setTenPointNegativeLimit() < option) {
      this.commonservice.openCustomerReviewPage("YES");
    } else {
      this.setStarRating();
      this.modalService.open(this.needimproveModal, {
        size: "sm",
        windowClass: "modalfeedback",
        centered: true,
      });
    }
  }
  onSubmitTenPointScale() {
    this.formal_ratting = this.tenPointValue.toString();

    let res: Response;
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    const data_json = {
      slug: this.slug_value,
      thumbs: null,
      faces: null,
      formal_rating: this.formal_ratting,
      review_scale_type: "TEN_POINT_SCALE",
    };

    this.tenPointValueSubmitted = true;

    const data_service = this.HttpService.put(
      this.BASE_URL.REVIEW_RATING_API,
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.tenPointValueSubmitted = false;
        this.toastrService.warning(error.error.message);
      },
      () => {
        this.tenPointValueSubmitted = false;
      }
    );
    this.ScaleOptionCheckTenPointScale(this.tenPointValue);
  }

  ngOnInit() {
    this.loading = true;
    this.initialData();
    this.commonservice.commonData.subscribe((data: any) => {
      if (data != null) {
        console.log("improvement", data);
        this.business_name = data["business_name"];
        this.logo_url = data["business_logo"];
        this.customer_name = data["contact_name"];
        this.consumer_choice = data["consumer_link"];
        this.feedback_scale = data["feedback_scale"];
        this.auto_redirect = data["auto_redirect"];
        this.negative_rating = data["negative_rating"];
        this.optionForWhatsApp = data["is_opted_in"];
        this.loading = false;

        if (
          data["google"] !== undefined &&
          data["google"].google_link !== null
        ) {
          this.reviewsby.push({ google: data["google"].google_link });
        }
        if (
          data["facebook"] !== undefined &&
          data["facebook"].fb_link !== null
        ) {
          this.reviewsby.push({ facebook: data["facebook"].fb_link });
        }
        if (data["custom"] !== undefined) {
          data["custom"].forEach((val: any, key: any) => {
            if (val.url !== null) {
            }
            if (val.type === "zomato") {
              this.reviewsby.push({ zomato: val.url });
            }
            if (val.type === "trip_advisor") {
              this.reviewsby.push({ trip_advisor: val.url });
            }
            if (val.type === "practo") {
              this.reviewsby.push({ practo: val.url });
            }
            if (val.type === "just_dail") {
              this.reviewsby.push({ just_dail: val.url });
            }
            if (val.type === "amazon") {
              this.reviewsby.push({ amazon: val.url });
            }
          });
        }
        const auto_redirect = this.storage.get("auto_redirect");
        if (auto_redirect != "null") {
          const redirectLink = this.reviewsby.reduce((acc, cv) => {
            return { ...acc, ...cv };
          }, {});
          this.redirectLink = redirectLink[auto_redirect];
        }
      }
    });

    this.commonservice.getData();
  }
  optedinWhatsApp(optionForWhatsApp) {
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    var data_json = {
      is_optin: optionForWhatsApp,
    };
    const data_service = this.HttpService.put(
      this.BASE_URL.OPTIN(this.slug_value),
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        console.log(data);
        //  this.toastrService.success(data.data['message']);
      },
      (error) => {
        this.toastrService.warning(error.error.message);
      },
      () => {}
    );
  }
  initialData() {
    this.reviewp = "Hi ";
    this.reviewp1 = "Your experience matters to us. Please tell us how we did!";
    this.reviewlike = "assets/gifs/1.png";
    this.reviewlike1 = "assets/images/thumbs-up-hand-symbol.svg";
    this.reviewdislike = "assets/gifs/2.png";
    this.reviewdislike1 = "assets/images/thumbs-down-silhouette.svg";
    this.poweredby = "Powered by";
    this.poweredby1 = "assets/images/zceppadark.svg";
    this.reviewlikeStyle = {
      "background-color": "transparent",
      width: "auto",
      padding: "0",
      "font-size": "18px",
      background: "transparent",
      color: "#fff",
      margin: "auto",
      "margin-bottom": "20px",
      "margin-top": "20px",
    };
    this.reviewdislikeStyle = {
      padding: "0",
      "font-size": "14px",
      background: "transparent",
      color: "#4a4a4a",
      border: "0px solid #333",
      "margin-top": "10px",
    };
    this.reviewlikeStyle1 = {
      padding: "7px 15px",
      background: "#03c0c2",
      color: "#fff",
      display: "block",
    };
    this.reviewdislikeStyle1 = {
      padding: "7px 15px",
      background: "#f1f1f1",
      color: "#4a4a4a",
      border: "0px solid #333",
      display: "block",
    };
  }

  // reviewRating(){
  //   let res: Response;
  //   this.route.params.forEach(val => {
  //     this.slug_value = val['id'];
  //   });
  //   const data_json = {
  //     'slug': this.slug_value,
  //     'thumbs': 'thumbs_up',
  //   };

  //   const data_service = this.HttpService.put(this.BASE_URL.REVIEW_RATING_API, data_json);
  //   data_service.subscribe((data: Response) => {
  //     res = data;
  //   }, error => {
  //     this.toastrService.warning(error.error.message);
  //   }, () => {

  //   });
  // }

  /**
   * open social review page
   *
   * @memberof ReviewImprovementComponent
   */
  openSocialReviewThumbsUp() {
    let res: Response;
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    const data_json = {
      slug: this.slug_value,
      thumbs: "thumbs_up",
      faces: null,
      formal_rating: null,
      review_scale_type: "TWO_POINT_SCALE",
    };

    const data_service = this.HttpService.put(
      this.BASE_URL.REVIEW_RATING_API,
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.warning(error.error.message);
      },
      () => {}
    );
    this.setStarRating("positive");
    this.commonservice.openCustomerReviewPage("YES");
  }

  openSocialReviewThumbsDown() {
    let res: Response;
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    const data_json = {
      slug: this.slug_value,
      thumbs: "thumbs_down",
      faces: null,
      formal_rating: null,
      review_scale_type: "TWO_POINT_SCALE",
    };

    const data_service = this.HttpService.put(
      this.BASE_URL.REVIEW_RATING_API,
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.warning(error.error.message);
      },
      () => {}
    );
    this.setStarRating("negative");

    this.modalService.open(this.needimproveModal, {
      size: "sm",
      windowClass: "modalfeedback",
      centered: true,
    });
  }

  openSocialReviewSmiley() {
    let res: Response;
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    const data_json = {
      slug: this.slug_value,
      thumbs: null,
      faces: "5",
      formal_rating: null,
      review_scale_type: "TWO_POINT_SCALE",
    };

    const data_service = this.HttpService.put(
      this.BASE_URL.REVIEW_RATING_API,
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.warning(error.error.message);
      },
      () => {}
    );
    this.setStarRating("positive");
    this.commonservice.openCustomerReviewPage("YES");
  }
  openSocialReviewSad() {
    let res: Response;
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    const data_json = {
      slug: this.slug_value,
      thumbs: null,
      faces: "1",
      formal_rating: null,
      review_scale_type: "TWO_POINT_SCALE",
    };

    const data_service = this.HttpService.put(
      this.BASE_URL.REVIEW_RATING_API,
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.warning(error.error.message);
      },
      () => {}
    );
    this.modalService.open(this.needimproveModal, {
      size: "sm",
      windowClass: "modalfeedback",
      centered: true,
    });
    this.setStarRating("negative");
  }

  ScaleOptionCheck(option) {
    if (this.negative_rating < option) {
      this.commonservice.openCustomerReviewPage("YES");
    } else {
      this.setStarRating();
      this.modalService.open(this.needimproveModal, {
        size: "sm",
        windowClass: "modalfeedback",
        centered: true,
      });
    }
  }

  sendScaleValue(option) {
    if (option == 5) {
      this.formal_ratting = "5";
    } else if (option == 4) {
      this.formal_ratting = "4";
    } else if (option == 3) {
      this.formal_ratting = "3";
    } else if (option == 2) {
      this.formal_ratting = "2";
    } else if (option == 1) {
      this.formal_ratting = "1";
    }
    let res: Response;
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    const data_json = {
      slug: this.slug_value,
      thumbs: null,
      faces: null,
      formal_rating: this.formal_ratting,
      review_scale_type: "FIVE_POINT_SCALE",
    };

    const data_service = this.HttpService.put(
      this.BASE_URL.REVIEW_RATING_API,
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.warning(error.error.message);
      },
      () => {}
    );
    this.ScaleOptionCheck(option);
  }

  sendScaleValueFaces(option) {
    if (option == 5) {
      this.faces_ratting = "5";
    } else if (option == 4) {
      this.faces_ratting = "4";
    } else if (option == 3) {
      this.faces_ratting = "3";
    } else if (option == 2) {
      this.faces_ratting = "2";
    } else if (option == 1) {
      this.faces_ratting = "1";
    }
    let res: Response;
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    const data_json = {
      slug: this.slug_value,
      thumbs: null,
      faces: this.faces_ratting,
      formal_rating: null,
      review_scale_type: "FIVE_POINT_SCALE",
    };

    const data_service = this.HttpService.put(
      this.BASE_URL.REVIEW_RATING_API,
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.warning(error.error.message);
      },
      () => {}
    );
    this.ScaleOptionCheck(option);
  }

  setStarRating(
    selected_two_point_slug: "negative" | "positive" | null = null
  ) {
    if (this.feedback_scale == "2") {
      if (
        this.consumer_choice == "Formal" ||
        this.consumer_choice == "Friendly"
      ) {
        if (selected_two_point_slug == "positive") {
          this.selected_rating = 5;
        } else {
          this.selected_rating = this.negative_rating;
        }
      }
    } else if (this.feedback_scale == "5") {
      if (this.consumer_choice == "Formal") {
        this.selected_rating = Number(this.formal_ratting);
      } else {
        this.selected_rating = Number(this.faces_ratting);
      }
    } else if (this.feedback_scale == "10") {
      if (this.consumer_choice == "Formal") {
        // for 10 point scale, convert the selected rating into 5 point rating
        let ratingConversion: number = Math.round(
          Number(this.formal_ratting) / 2
        );
        this.selected_rating = ratingConversion;
      }
    }
  }

  thankyouModal() {
    let res: Response;
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    if (this.feedback === undefined || this.feedback === "") {
      this.toastrService.error("Please Enter Feedback");
      return;
    }
    if (this.selected_rating === 0) {
      this.toastrService.error("Please Choose Ratings");
      return;
    }
    const json_data = {
      slug: this.slug_value,
      feedback_text: this.feedback,
      feedback_star: this.selected_rating,
    };
    const data_service = this.HttpService.postjson(
      this.BASE_URL.SMS_SLUG_REQUEST_URL,
      json_data
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {},
      () => {
        if (res.code === 200 || res.code === 201) {
          this.modalService.dismissAll(this.needimproveModal);
          // Commented this code for future use.
          // Uncommented this code to revert back changes.
          if (this.auto_redirect !== "null") {
            this.modalService.open(this.thankyoumodal, {
              size: "sm",
              windowClass: "modalfeedback",
              centered: true,
            });
            this.feedback = "";
          } else {
            // redirect to external review platform page
            this.closeModal();
            this.commonservice.openCustomerReviewPage("YES", true);
          }

          // redirect to external review platform page
          // Commented this code for future use.
          // this.closeModal();
          // this.commonservice.openCustomerReviewPage('YES', true);
        } else {
          this.toastrService.error(res.data["message"]);
        }
      }
    );
  }
  closeModal() {
    this.modalService.dismissAll(this.thankyoumodal);
  }
}
